/**
 * 시스템 로그 (슈퍼관리자용)
 * 시스템 오류, 서비스 관리, 고객사 관리 등의 로그를 조회할 수 있습니다.
 */
import ActivityLogs from '@/components/settings/activity-logs/admin';

/**
 * 슈퍼관리자용 시스템 로그 컴포넌트
 * customerId를 null로 전달하여 전체 시스템 로그를 표시하고,
 * logType을 'system_logs'로 설정하여 관리자 활동 + 시스템 로그만 표시합니다.
 */
const SystemLogs: React.FC = () => {
  return <ActivityLogs customerId={null} logType="system_logs" />;
};

export default SystemLogs;
